var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('modal-text',{attrs:{"show":_vm.showModal,"title":_vm.title,"msg":_vm.msg},on:{"close":function($event){return _vm.close()}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }